/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */
import type {
    QueryClient,
    QueryKey,
    QueryObserverOptions,
    UseQueryResult,
} from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

import fetch from 'Common/utils/query/workRequestClient.ts'
import type {
    RequestConfig,
    ResponseConfig,
    ResponseErrorConfig,
} from 'Common/utils/query/workRequestClient.ts'

import type { GetV1CustomergroupsQueryResponse } from '../../types/GetV1Customergroups.ts'

export const getV1CustomergroupsQueryKey = () => [{ url: '/v1/CustomerGroups' }] as const

export type GetV1CustomergroupsQueryKey = ReturnType<typeof getV1CustomergroupsQueryKey>

/**
 * {@link /v1/CustomerGroups}
 */
export async function getV1Customergroups(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const { client: request = fetch, ...requestConfig } = config

    const res = await request<
        GetV1CustomergroupsQueryResponse,
        ResponseErrorConfig<Error>,
        unknown
    >({ method: 'GET', url: `/v1/CustomerGroups`, ...requestConfig })
    return res
}

export function getV1CustomergroupsQueryOptions(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const queryKey = getV1CustomergroupsQueryKey()
    return queryOptions<
        ResponseConfig<GetV1CustomergroupsQueryResponse>,
        ResponseErrorConfig<Error>,
        ResponseConfig<GetV1CustomergroupsQueryResponse>,
        typeof queryKey
    >({
        queryKey,
        queryFn: async ({ signal }) => {
            config.signal = signal
            return getV1Customergroups(config)
        },
    })
}

/**
 * {@link /v1/CustomerGroups}
 */
export function useGetV1Customergroups<
    TData = ResponseConfig<GetV1CustomergroupsQueryResponse>,
    TQueryData = ResponseConfig<GetV1CustomergroupsQueryResponse>,
    TQueryKey extends QueryKey = GetV1CustomergroupsQueryKey,
>(
    options: {
        query?: Partial<
            QueryObserverOptions<
                ResponseConfig<GetV1CustomergroupsQueryResponse>,
                ResponseErrorConfig<Error>,
                TData,
                TQueryData,
                TQueryKey
            >
        > & { client?: QueryClient }
        client?: Partial<RequestConfig> & { client?: typeof fetch }
    } = {},
) {
    const { query: queryConfig = {}, client: config = {} } = options ?? {}
    const { client: queryClient, ...queryOptions } = queryConfig
    const queryKey = queryOptions?.queryKey ?? getV1CustomergroupsQueryKey()

    const query = useQuery(
        {
            ...getV1CustomergroupsQueryOptions(config),
            queryKey,
            ...queryOptions,
        } as unknown as QueryObserverOptions,
        queryClient,
    ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

    query.queryKey = queryKey as TQueryKey

    return query
}
